import {observer} from "mobx-react";
import type {User} from "../../../../data/models/User";
import {XyiconFeature} from "../../../../generated/api/base";
import {useAppStore} from "../../../../StateManager";
import type {IInputProps} from "../clicktoedit/FieldInput";
import {MultiSelectInput} from "../multiselect/MultiSelectInput";
import {compareUsers, renderUserValue} from "../../../../data/models/field/datatypes/PeopleSingle";

export const PeopleMultipleChoiceInput = observer((props: IInputProps) => {
	const {value, onChange} = props;
	const appState = useAppStore((state) => state.appState);
	const allUsers = appState.actions.getList<User>(XyiconFeature.User).toSorted(compareUsers);
	const selectedUsers = (value as User[]) ?? [];

	return (
		<MultiSelectInput
			{...props}
			selected={selectedUsers}
			options={allUsers}
			render={renderUserValue}
			onChange={(users: User[]) => onChange(users.map((u) => u.id))}
		/>
	);
});
